import {API_URL} from "@/shared/lib/api";
import {AutoEquTableInterface} from "@/features/types/AutoEquTableInterface";

export async function getAutoEquTableData(f_ord_num: string, f_ord_d: string): Promise<AutoEquTableInterface[]> {
    const res = await fetch(`${API_URL}/index.php?action=auto-equ-table`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        credentials: "include",
        body: JSON.stringify({f_ord_num, f_ord_d}),
    });

    if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
    return await res.json();
}

